module.exports = __webpack_public_path__ + "static/contact-7a6b72f571d468d212e7f6b6ba918470.png";